(function (Global, $) {
    /**
     * Parametres possibles (params) :
     * results : parametre avec les data renvoyées par le back
     * success : parametre type function, servant de callback dans le cas où il n'y a pas d'erreur
     * form : parametre de type element jquery, dans le cas d'un mauvais remplissage des champs dans le formulaire en question
     */
    Global.ajaxCallback = function (params) {
        var data = typeof params.results == 'string' ? JSON.parse(params.results) : params.results;

        if (data.feedback) {
            showMessage(data)
        }

        handleSuccessOrNot(data, params);
        
        setTimeout(function () {
            if (!Global.REFRESH || Global.URL_REDIRECT_TYPE == "download") {
                $('.loading').removeClass('loading');
                $('.loading-search').removeClass('loading-search');
            }
        }, 300)      
    }

    function showMessage(data) {
        $.Topic('show-message').publish(data.feedback, data.isSuccess ? 'success' : 'error');
    }

    function handleSuccessOrNot(data, params) {
        if (data.isSuccess) {
            onSuccess(data, params)
        } else {
            onError(data, params)
        }
    }

    function onSuccess(data, params) {
        if (URL_REDIRECT && URL_REDIRECT !== '' || data.data && data.data.redirectUrl && data.data.redirectUrl !== '') {
            var url = '';
            if (data.data.redirectUrl && data.data.redirectUrl !== '') url = data.data.redirectUrl; //Url renvoyée par la réponse Ajax
            else if (URL_REDIRECT && URL_REDIRECT !== '') url = URL_REDIRECT;  //Url paramétré par un élement front

            return Global.location.replace(url);
        }
        if (data.data.html && data.data.complete) {
            $('.page').html(data.data.html);
        } else {
            if (!params.success || typeof params.success !== 'function') return Global.location.reload();
            params.success(data);
        }
    }

    function onError(data, params) {
        if (data.errors && params.form) $.manageErrors(params.form, data.errors);
        if (data.data && data.data.redirectUrl)
            return Global.location.replace(data.data.redirectUrl);
    }
}(window, jQuery));